
export default {
  props: ["error"],
  created() {
    this.$router.push({
        path: `/`
    })
  },
  methods: {
  }
}
